// Re-export shared utils for backward compatibility
export { normalizeUrl, extractGoogleMeetCode } from '@shared/utils/calendar-matching'

export const meetingCountdownFormatter = (
  _value: number,
  _unit: string,
  _suffix: string,
  epochMilliseconds: number,
  _nextFormatter: any,
  now: () => number,
): React.ReactNode => {
  const currentTime = now()
  const timeDiff = epochMilliseconds - currentTime

  // If the meeting has started (time difference is 0 or negative)
  if (timeDiff <= 0) {
    return 'Your meeting has started'
  }

  // Convert to seconds for countdown
  const secondsRemaining = Math.floor(timeDiff / 1000)

  if (secondsRemaining <= 60) {
    return 'Now'
  }

  // For times greater than 60 seconds, show minutes
  const minutesRemaining = Math.floor(secondsRemaining / 60)
  if (minutesRemaining === 1) {
    return 'Starts in 1 minute'
  }
  return `Starts in ${minutesRemaining} minutes`
}
